import { useEffect, useRef, useState } from 'react';
import { CustomCalendar } from '../../../component/calendar/CustomCalendar';
import {
  formatDashFormToEightDigitString,
  transferDateToEightStringSplitByDash,
} from '../../../function/replaceString';
import styled, { css, useTheme } from 'styled-components';
import { CSSTransition } from 'react-transition-group';
import { IoIosArrowForward } from 'react-icons/io';
import { IoIosArrowBack } from 'react-icons/io';
import * as Styled from '../../anonymouse/pages/LoginPageStyled';
import '../style/ProductionOverviewStyle.css';
import { IoMdArrowDropdown } from 'react-icons/io';
import {
  getNextMonthStartDayFromDahedDateString,
  getPrevMonthStartDayFromDahedDateString,
} from '../../../component/calendar/function/CustomCalendarFunction';
import useFetch from '../../../api/useFetch';
import {
  productionBetweenDaysGetApi,
  productionDaylistFindApi,
  ProductionExistDayReqType,
  ProductionSimpleType,
  ProductItem,
  productItemListGetApi,
  workbayListGetApi,
  WorkbayType,
} from '../../../api/apiConfig';
import { useHeaderButtons } from '../../../component/header/HeaderButtonProvider';
import SquareButton from '../../../component/button/SquareButton';
import { BiWindowClose } from 'react-icons/bi';
import { FiTrash2 } from 'react-icons/fi';
import { ProductionTable } from '../../../component/table/TableComponents/ProductionTable';

export const ProductionOverview = () => {
  const theme = useTheme();

  //작업장리스트 변수
  const [workbayList, setWorkbayList] = useState<WorkbayType[]>([]);

  const [periodStartDate, setPeriodStartDate] = useState<string>(
    transferDateToEightStringSplitByDash(new Date())
  );

  const [periodEndDate, setPeriodEndDate] = useState<string>(
    transferDateToEightStringSplitByDash(new Date())
  );

  //제품 리스트
  const [productItemList, setProductItemList] = useState<ProductItem[]>([]);

  //선택된 제품 리스트
  const [selectedProductItemList, setSelectedProductItemList] = useState<
    ProductItem[]
  >([]);

  //제품 검색어 변수
  const [productSearchTerm, setProductSearchTerm] = useState<string>('');

  const { setButtons } = useHeaderButtons();

  const [selectedDay, setSelectedDay] = useState(
    transferDateToEightStringSplitByDash(new Date())
  );

  const [itemGroupOption, setItemGroupOption] = useState<
    'none' | 'daily' | 'all'
  >('none');

  const [pageMode, setPageMode] = useState<'DAILY' | 'PERIOD'>('DAILY');

  const selectedDayRef = useRef<{ year: string; month: string } | null>(null);

  //선택된 작업장
  const [selectedWorkbay, setSelectedWorkbay] = useState<WorkbayType>();

  //작업장 드롭다운 관리
  const [workbayDropdownOpen, setWorkbayDropdownOpen] =
    useState<boolean>(false);

  //아이템 드롭다운 관리
  const [productItemDropdownOpen, setProductItemDropdownOpen] =
    useState<boolean>(false);

  const [markedDays, setMarkedDays] = useState<string[]>([]);

  const [inTransition, setInTransition] = useState(false);

  const [productionResponseData, setProductionResponseData] = useState<
    ProductionSimpleType[]
  >([]);

  const { fetch: fetchProductionDaylistFindApi } = useFetch({
    fetchFunction: productionDaylistFindApi,
    onSuccess: (data: string[]) => {
      setMarkedDays(data);
    },
  });

  /** 생산리스트 조회 */
  const { fetch: fetchProductionBetweenDaysGetApi } = useFetch({
    fetchFunction: productionBetweenDaysGetApi,
    onSuccess: (data: ProductionSimpleType[]) =>
      setProductionResponseData(data),
  });

  //작업장 리스트 조회 api
  const { fetch: fetchGetWorkbayList } = useFetch({
    fetchFunction: workbayListGetApi,
    onSuccess: (data: WorkbayType[]) => {
      const defaultValue = { id: -1, workbayCode: 'none', workbayName: '전체' };
      setWorkbayList([
        defaultValue,
        ...data.filter((data) => data.workbayCode !== '100'),
      ]);
      setSelectedWorkbay(defaultValue);
    },
  });

  //품목중 제품들만 리스트 조회
  const { fetch: fetchGetProductItemList } = useFetch({
    fetchFunction: productItemListGetApi,
    onSuccess: (data: ProductItem[]) => setProductItemList(data),
  });

  // const handlePageSwitch = () => {
  //   if (inTransition) return;

  //   setInTransition(true);

  //   setTimeout(() => {
  //     setPageMode(pageMode === 'DAILY' ? 'PERIOD' : 'DAILY');
  //     setInTransition(false);
  //   }, pageTransitionDuration);
  // };

  useEffect(() => {
    fetchGetWorkbayList();
    fetchGetProductItemList();
  }, []);
  useEffect(() => {
    if (pageMode === 'DAILY' && selectedDay !== null) {
      setPeriodStartDate(selectedDay);
      setPeriodEndDate(selectedDay);
    }
    const [year, month, day] = selectedDay.split('-');
    if (
      selectedDayRef.current === null ||
      selectedDayRef.current.year !== year ||
      selectedDayRef.current.month !== month
    ) {
      selectedDayRef.current = {
        year: year,
        month: month,
      };
      const dto: ProductionExistDayReqType = {
        targetYear: year,
        targetMonth: month,
      };
      fetchProductionDaylistFindApi(dto);
    }
  }, [selectedDay, pageMode]);

  useEffect(() => {
    //헤더에 버튼 추가
    setButtons(
      <>
        <SquareButton
          width={150}
          text={
            pageMode === 'DAILY' ? '기간별 조회로 전환' : '일자별 조회로 전환'
          }
          colorType='ACTIVE'
          onClick={() => setPageMode(pageMode === 'DAILY' ? 'PERIOD' : 'DAILY')}
        />
      </>
    );
    // 페이지가 바뀌면 버튼 초기화
    return () => setButtons(null);
  }, [setButtons, pageMode]);

  const WorkbayDropdownBox = () => {
    return (
      <>
        {workbayList.length > 0 ? (
          workbayList.map((workbay) => (
            <DropdownItem
              onClick={() => {
                setSelectedWorkbay(workbay);
                setWorkbayDropdownOpen(!workbayDropdownOpen);
              }}
              included={
                selectedWorkbay !== undefined &&
                selectedWorkbay.id === workbay.id
              }
            >
              {workbay.workbayName}
            </DropdownItem>
          ))
        ) : (
          <div>작업장 정보가 없습니다</div>
        )}
      </>
    );
  };

  const handleItemGroupRadioClick = (id: string) => {
    const radioInput = document.getElementById(id) as HTMLInputElement;
    if (radioInput) {
      radioInput.checked = true;
    }
    const idSplit = id.split('-');
    const optionFromId = idSplit[idSplit.length - 1];
    setItemGroupOption(optionFromId as 'none' | 'daily' | 'all');
  };

  return (
    <>
      {pageMode === 'DAILY' ? (
        // <CalendarWrapper>
        //   <CursorClickArea
        //     onClick={() =>
        //       setSelectedDay(
        //         transferDateToEightStringSplitByDash(
        //           getPrevMonthStartDayFromDahedDateString(selectedDay)
        //         )
        //       )
        //     }
        //   >
        //     <IoIosArrowBack size={40} color='#79797e' />
        //   </CursorClickArea>
        //   <CustomCalendar
        //     selectedDay={selectedDay}
        //     setSelectedDay={(date: Date) =>
        //       setSelectedDay(transferDateToEightStringSplitByDash(date))
        //     }
        //     markedDays={markedDays}
        //     hideControl
        //   />
        //   <CursorClickArea
        //     onClick={() =>
        //       setSelectedDay(
        //         transferDateToEightStringSplitByDash(
        //           getNextMonthStartDayFromDahedDateString(selectedDay)
        //         )
        //       )
        //     }
        //   >
        //     <IoIosArrowForward size={40} color='#79797e' />
        //   </CursorClickArea>
        // </CalendarWrapper>

        <CalendarWrapper>
          <CustomCalendar
            selectedDay={selectedDay}
            setSelectedDay={(date: Date) =>
              setSelectedDay(transferDateToEightStringSplitByDash(date))
            }
            markedDays={markedDays}
            hideControl
          />
          <div
            style={{
              display: 'flex',
              flexDirection: 'row',
              alignItems: 'center',
              height: '30px',
              color: theme.colors.charcoal,
            }}
          >
            <input
              type='checkbox'
              className='checkbox'
              checked={itemGroupOption === 'daily'}
              onChange={(e) =>
                e.target.checked
                  ? setItemGroupOption('daily')
                  : setItemGroupOption('none')
              }
              style={{ alignContent: 'start', width: '20px', height: '20px' }}
            />
            동일품목 묶기
          </div>
        </CalendarWrapper>
      ) : (
        <PeriodContainer>
          <Row>
            <RowLabel>작업장</RowLabel>
            <RowContent>
              <div
                onClick={() => setWorkbayDropdownOpen(!workbayDropdownOpen)}
                style={{
                  cursor: 'pointer',
                  position: 'relative',
                  width: 'fit-content',
                  display: 'flex',
                  flexDirection: 'row',
                  alignContent: 'center',
                }}
              >
                {selectedWorkbay && selectedWorkbay.workbayName}
                <IoMdArrowDropdown size={20} style={{ paddingTop: '2px' }} />
                <WorkbayDropdownContainer show={workbayDropdownOpen}>
                  <WorkbayDropdownBox />
                </WorkbayDropdownContainer>
              </div>
            </RowContent>
          </Row>
          <Row style={{ position: 'relative' }}>
            <RowLabel>품목</RowLabel>
            <RowContent>
              <div
                style={{
                  cursor: 'pointer',
                  width: 'fit-content',
                  display: 'flex',
                  flexDirection: 'row',
                  alignContent: 'center',
                }}
              >
                <>
                  <div
                    onClick={() =>
                      setProductItemDropdownOpen(!productItemDropdownOpen)
                    }
                    style={{
                      cursor: 'pointer',
                      minWidth: '80px',
                      textAlign: 'center',
                    }}
                  >
                    추가하기
                  </div>
                  <SelectedProdItemContainer>
                    {selectedProductItemList.length > 0 &&
                      selectedProductItemList.map((item) => (
                        <SelectedProdItem>
                          <FiTrash2
                            size={15}
                            color={theme.colors.red}
                            style={{
                              cursor: 'pointer',
                            }}
                            onClick={() =>
                              setSelectedProductItemList((prev) =>
                                prev.filter((prevItem) => prevItem !== item)
                              )
                            }
                          />
                          <SelectedProdItem>{item.PROD_DES}</SelectedProdItem>
                        </SelectedProdItem>
                      ))}
                  </SelectedProdItemContainer>
                </>

                <DropdownBase show={productItemDropdownOpen}>
                  <ProductDropdownHeader>
                    <div
                      style={{
                        height: '26px',
                        backgroundColor: '#1f48d4',
                        marginBottom: '3px',
                        textAlign: 'end',
                        alignContent: 'center',
                        paddingRight: '5px',
                      }}
                    >
                      <BiWindowClose
                        size={20}
                        color='white'
                        style={{ cursor: 'pointer' }}
                        onClick={() => setProductItemDropdownOpen(false)}
                      />
                    </div>
                    <div style={{ padding: '3px', display: 'flex' }}>
                      <Styled.Input
                        placeholder='제품명 검색'
                        value={productSearchTerm}
                        style={{ marginBottom: '5px', maxHeight: '18px' }}
                        onChange={(e) => setProductSearchTerm(e.target.value)}
                      />
                    </div>
                  </ProductDropdownHeader>
                  <ProductDropdownBody>
                    {productItemList.length > 0 ? (
                      productItemList
                        .filter((product) =>
                          productSearchTerm?.trim()
                            ? product.PROD_DES.includes(productSearchTerm)
                            : true
                        )
                        .map((product) => (
                          <DropdownItem
                            key={product.PROD_DES} // 혹은 적절한 유일 식별자 사용
                            onClick={() => {
                              !selectedProductItemList.some(
                                (data) => data.id === product.id
                              ) &&
                                setSelectedProductItemList((prev) => [
                                  ...prev,
                                  product,
                                ]);
                            }}
                            included={selectedProductItemList.some(
                              (data) => data.id === product.id
                            )}
                          >
                            {product.PROD_DES}
                          </DropdownItem>
                        ))
                    ) : (
                      <div>작업장 정보가 없습니다</div>
                    )}
                  </ProductDropdownBody>
                </DropdownBase>
              </div>
            </RowContent>
          </Row>
          <Row>
            <RowLabel>조회시작일</RowLabel>
            <RowContent>
              <DateInput
                type='date'
                value={periodStartDate}
                onChange={(e) => {
                  setPeriodStartDate(e.target.value);
                }}
              />
            </RowContent>
            <RowLabel>조회종료일</RowLabel>
            <RowContent>
              <DateInput
                type='date'
                value={periodEndDate}
                onChange={(e) => {
                  setPeriodEndDate(e.target.value);
                }}
              />
            </RowContent>
          </Row>
          <Row>
            <RowLabel>동일품목 묶기</RowLabel>
            <RowContent>
              <div
                style={{ display: 'flex', alignItems: 'center', gap: '6px' }}
              >
                <div
                  onClick={() =>
                    handleItemGroupRadioClick('item-gruop-option-none')
                  }
                  style={{ cursor: 'pointer' }}
                >
                  <input
                    type='radio'
                    name='item-group-option'
                    value='none'
                    defaultChecked={true}
                    id='item-gruop-option-none'
                    readOnly // input의 상태 변경을 상위 div의 onclick에 완전히 위임
                  />
                  없음
                </div>
                <div
                  onClick={() =>
                    handleItemGroupRadioClick('item-gruop-option-daily')
                  }
                  style={{ cursor: 'pointer' }}
                >
                  <input
                    type='radio'
                    name='item-group-option'
                    value='daily'
                    id='item-gruop-option-daily'
                    readOnly // input의 상태 변경을 상위 div의 onclick에 완전히 위임
                  />
                  생산일 기준
                </div>
                <div
                  onClick={() =>
                    handleItemGroupRadioClick('item-gruop-option-all')
                  }
                  style={{ cursor: 'pointer' }}
                >
                  <input
                    type='radio'
                    name='item-group-option'
                    value='all'
                    id='item-gruop-option-all'
                    readOnly // input의 상태 변경을 상위 div의 onclick에 완전히 위임
                  />
                  전체 묶음
                </div>
              </div>
            </RowContent>
          </Row>
        </PeriodContainer>
      )}
      <div style={{ height: '30px' }} />
      <ProductionTable
        periodStartDate={periodStartDate}
        periodEndDate={periodEndDate}
        itemGruopOption={itemGroupOption}
        selectedItemList={selectedProductItemList}
        selectedWorkbay={selectedWorkbay}
      />
    </>
  );
};

const CalendarWrapper = styled.div`
  width: 100%;
  display: flex;
  flex-direction: row;
  /* justify-content: center; */
  /* align-items: center; */
  gap: 20px;
`;

const CursorClickArea = styled.div`
  width: 60px;
  height: 60px;
  align-content: center;
  text-align: center;
  cursor: pointer;
`;

const DropdownBase = styled.div<{ show: boolean }>`
  font-weight: 500;
  display: flex;
  flex-direction: column;
  border-radius: 5px;
  overflow: hidden;
  position: absolute;
  background-color: white;
  left: 100%;
  margin-left: 15px;
  top: 0px;
  z-index: 10;
  box-shadow: 0 2px 8px rgba(71, 71, 71, 0.678);
  transform: ${({ show }) => (show ? 'scale(1)' : 'scale(0)')};
  transform-origin: top left;
  transition: transform 0.3s ease, width 0.3s ease, height 0.3s ease;
`;
const DropdownItem = styled.div<{ included: boolean }>`
  width: 100%;
  padding: 4px 1px;
  ${({ included }) =>
    included
      ? css`
          background-color: ${({ theme }) => theme.colors.lime};
        `
      : css`
          cursor: pointer;
          &:hover {
            background-color: ${({ theme }) => theme.colors.lightGray};
          }
        `}
`;
const WorkbayDropdownContainer = styled(DropdownBase)`
  padding: 5px;
  gap: 6px;
  width: 170px;
`;

const PeriodContainer = styled.div`
  max-width: 800px;
  display: flex;
  flex-direction: column;
`;

const Row = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  align-items: stretch;

  &:not(:last-child) {
    border-bottom: 1px solid #b8b8b8;
  }
`;

const RowLabel = styled.div`
  flex: 0 0 120px;
  background-color: #d9d9d9;
  font-size: 15px;
  align-content: center;
  text-align: center;
  padding: 4px 0px;
  font-weight: 700;
`;

const RowContent = styled.div`
  flex-grow: 1;
  padding: 4px 10px;
  background-color: white;
`;

const ProductDropdownHeader = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
`;

const ProductDropdownBody = styled.div`
  position: relative;
  gap: 6px;
  margin: 7px;
  display: flex;
  flex-direction: column;
  width: 220px;
  overflow-x: hidden;
  overflow-y: scroll;
  min-height: 350px;
  max-height: 500px;
  background-color: ${({ theme }) => theme.colors.whiteGray};
`;

const SelectedProdItemContainer = styled.div`
  display: flex;
  flex-wrap: wrap;
  flex-direction: row;
  align-items: center;
  gap: 12px;
`;

const SelectedProdItem = styled.div`
  display: flex;
  padding: 0px 4px;
  flex-direction: row;
  gap: 3px;
  align-items: center;
  font-size: 12px;
  font-weight: 700;
`;

const DateInput = styled.input`
  width: 100%;
  color: #595b60;
  font-weight: 700;
  font-size: 14px;
  text-align: center;
  box-sizing: border-box;
  border: none;
  cursor: pointer;

  /* Webkit 브라우저에서 달력 아이콘 숨기기 */
  /* &::-webkit-calendar-picker-indicator {
    display: none;
    -webkit-appearance: none;
  }

  /* Firefox 브라우저에서 달력 아이콘 숨기기 */
  /*-moz-appearance: textfield; */
`;
